var path = '/var/www/mmscny-website/src/app/common/components/google-map/google-map.html';
var html = "<div class=google-map-box> <div class=google-map> <div id=map></div> </div> </div> <div class=transit-details> <ul> <li ng-repeat=\"transit in $ctrl.transitProviders\" ng-if=\"$ctrl.routeType === 'transit'\"> <div ng-repeat=\"agency in transit.line.agencies\"> <h2>{{agency.name}}</h2> <p>{{agency.phone}}</p> <p>{{agency.url}}</p> </div> </li> <li ng-repeat=\"transit in $ctrl.privateProviders\" ng-if=\"$ctrl.routeType === 'private'\"> <h2>{{transit.name}}</h2> <p>{{transit.phone}}</p> <p>{{transit.url}}</p> </li> </ul> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/google-map/google-map.html
// module id = 649
// module chunks = 0